import { render } from "./LayoutHeader.vue?vue&type=template&id=c6e4ad44&scoped=true&ts=true"
import script from "./LayoutHeader.vue?vue&type=script&lang=ts"
export * from "./LayoutHeader.vue?vue&type=script&lang=ts"

import "./LayoutHeader.vue?vue&type=style&index=0&id=c6e4ad44&lang=scss&scoped=true"

import exportComponent from "/home/blueflamehaze/Documents/Projects/certificates/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6e4ad44"]])

export default __exports__